import { Typography } from '@mui/material'
import { get } from 'lodash'
import React from 'react'

import AsOfDate from '../../components/AsOfDate'
import { NO_DATA_MESSAGE } from '../../utils/constants'
import FourColumnsDatapoints from '../FourColumnsDatapoints'
import ScrollingTable from '../Tables/ScrollingTable'

export default function PortfolioCharacteristics({ data, popups }) {
  const characteristics =
    get(data, 'portfolioCharacteristics') || get(data, 'characteristics')
  const asOfDate =
    characteristics?.[0]?.calendar?.date ||
    get(data, 'characteristics[0].calendar.date', '')
  const fundName = get(data, 'name', 'Fund')

  if (!characteristics || characteristics.length === 0) {
    return <Typography>{NO_DATA_MESSAGE}</Typography>
  }

  const datapoints = []
  const columns = characteristics[0]?.benchmarkValue
    ? [
        {
          Header: '',
          id: 'name',
          accessor: 'name',
          Cell: ({ value }) => <Typography variant="body2">{value}</Typography>,
        },
        {
          Header: fundName,
          id: 'fundValue',
          accessor: 'fundValue',
        },
        {
          Header: characteristics[0]?.benchmarkIndex?.name || 'Benchmark',
          id: 'benchmarkValue',
          accessor: 'benchmarkValue',
        },
      ]
    : []

  characteristics.forEach((obj) => {
    if (obj.fundValue && obj.name && !obj.benchmarkValue) {
      datapoints.push({
        value: obj.fundValue,
        label: obj.name,
        labelHasPopover: !!popups?.find(
          (popup) =>
            popup.field_name === obj.key ||
            popup.title === `Index - ${obj.name}`
        ),
        popover: popups?.find(
          (popup) =>
            popup.field_name === obj.key ||
            popup.title === `Index - ${obj.name}`
        ),
      })
    }
  })

  // Ensure datapoints is divisible by 4 for proper layout
  while (datapoints.length % 4 !== 0) {
    datapoints.push({})
  }

  return (
    <>
      <AsOfDate date={asOfDate} />
      {columns.length ? (
        <ScrollingTable data={characteristics} columns={columns} />
      ) : (
        <>
          {datapoints.map((_, index) =>
            index % 4 === 0 ? (
              <FourColumnsDatapoints
                key={index}
                datapoints={datapoints.slice(index, index + 4)}
              />
            ) : null
          )}
        </>
      )}
    </>
  )
}
